import { Component } from '@angular/core'
import { OrganizationSettingsContentComponent } from './organization-settings-content/organization-settings-content.component'
import { OrganizationSettingsSidebarComponent } from './organization-settings-sidebar/organization-settings-sidebar.component'

@Component({
  selector: 'app-organization-settings',
  imports: [OrganizationSettingsSidebarComponent, OrganizationSettingsContentComponent],
  templateUrl: './organization-settings.component.html',
  styleUrl: './organization-settings.component.scss',
  standalone: true
})
export class OrganizationSettingsComponent {}
